<div style="width:100%; background-color: #9fa8da; height: 65px; padding: 0px; left: 0px ">
  
  <div class="sis-app-tylersis-title" style="text-align:left; padding: 0px">
    <table style="width: 100%;">
      <tr>
        <td style="width: 45%;padding-top: 5px;">
          <span>Tyler SIS</span>
        </td>
        <td style="width: 55%;padding-top: 5px;">
          <span style="padding: 5px">Reports</span> 
        </td>
      </tr>
    </table>
   
      
        
    
  </div>
  


<div style="position:absolute;top:0px;right:0px;">


  <!-- <table>
        <tr>
            <td style="padding-left:10px;padding-right:20px;">
                <div (click)="closeReportingWindow()">
                    <div class="sis-footer-customIcon" style="right:0px;">-->
  <!-- <div style="margin-top:2px;">
                            <img src="./../assets/images/cancel-white.png" class="sis-header-icon" />
                        </div>
                        <div style="text-align:center;" translate>Close</div>

                    </div>
                </div>

            </td>
        </tr>
    </table>
    </div> -->
  <!-- <tyl-button style="float:right; color: white;" image="cancel white.png" translate label="Close" (clickEvent)="closeClick()"></tyl-button> -->


</div>

<!-- <div style="position:absolute;top:2px;left:0px;" *ngIf="!loginSettings.V10">
    <table>
      <tr>
        <td>
          <div style="color:white;font-size: 30px;vertical-align: middle;padding-left:15px;margin-top: 6px;">Reports</div>
        </td>
      </tr>
    </table>
  </div>
</div> -->